<p>
  Leider gab es bei Ihrer Bestellung ein Problem:
</p>
<p>
  {{errorMessage}}
</p>
<p>
  Bitte korrigieren Sie Ihre Eingabe und senden Sie die Bestellung ggf. erneut.
</p>

<div class="buttonRow">
  <button (click)="appController.previous()">Zurück</button>
</div>
